module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('popover-box', {
    ref: "popover",
    staticClass: "date-picker-popover",
    attrs: {
      "parent": _vm.parent,
      "direction": _vm.direction
    }
  }, [_c('date-picker', {
    attrs: {
      "not-before": _vm.notBefore,
      "not-after": _vm.notAfter,
      "lang": "en",
      "range": "",
      "confirm": ""
    },
    model: {
      value: (_vm.selectedDate),
      callback: function($$v) {
        _vm.selectedDate = $$v
      },
      expression: "selectedDate"
    }
  }), _vm._v(" "), _c('popover-checkmark-btn', {
    attrs: {
      "disabled": _vm.isInvalid
    },
    nativeOn: {
      "click": function($event) {
        return _vm.selectAttribute.apply(null, arguments)
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63498071"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/common/popover/DatePickerPopover.vue
// module id = 1912
// module chunks = 0